'use strict';

import { reverseUrl } from 'utils/django';
import versioner from 'incidents/versions/versioner';


export default {
  method: 'POST',
  getUrl: getUrl,
  resolve: {
    position: getCurrentPosition,
  },
  transformData: transformData,
  onSuccess: onSuccess,
};


function onSuccess(response, $incident, $context) {
  $incident.addLogEntry(response.data);
}


function getUrl($incident) {
  return reverseUrl('incidents:incident-log-list', {
    incident_uuid: $incident.uuid,
  });
}


export function resolveCurrentPosition(deferred, k, previousAttempts, rejectOnPermissionError) {
  if (k == null) k = 4;
  if (previousAttempts == null) previousAttempts = [];

  if (k == 0) {
    if (previousAttempts.length > 0) {
      previousAttempts.sort(function (a, b) {
        a.coords.accuracy - b.coords.accuracy;
      });
      return deferred.resolve(previousAttempts[0]);
    } else {
      return deferred.resolve();
    }
  }

  try {
    navigator.geolocation.getCurrentPosition(function (position) {
      var accuracy = position.coords.accuracy;
      var age = (new Date()).getTime() - position.timestamp;
      // If the accuracy (given in meters) is good, accept it
      if (accuracy < 30) {
        deferred.resolve(position);
        return;
      }
      // If the age (given is ms) is greater than the timeout, reject it and
      // do not add it to previous attempts.
      if (age > 10000) {
        resolveCurrentPosition(deferred, k - 1, previousAttempts);
        return;
      }
      // If it's not too stale, accept a reasonable accuracy
      if (accuracy < 200) {
        deferred.resolve(position);
        return;
      }
      // Finally, if it's not stale, but not accurate enough, keep trying, but wait a second.
      setTimeout(function () {
        previousAttempts.push(position);
        resolveCurrentPosition(deferred, k - 1, previousAttempts);
      }, 3000);
    }, function (error) {
      if (error.code === 1 && rejectOnPermissionError) {
        deferred.reject(error);
        return;
      }
      resolveCurrentPosition(deferred, k - 1, previousAttempts);
    }, {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeout: 10000,
    });
  } catch (e) {
    $log.error(e);
    resolveCurrentPosition(deferred, k - 1, previousAttempts);
  }
}


function getCurrentPosition($scope, $log, $window, $q) {
  'ngInject';

  if ($scope.$context.appendLatlng) {
    var deferred = $q.defer();
    deferred.promise.then(function (position) {
      return position;
    });
    resolveCurrentPosition(deferred);
    return deferred.promise;
  }
}


// Add latitude and longitude to log entries when available
function transformEntry(entry, scope) {
  try {
    entry.lat = scope.$resolve.position.coords.latitude.toFixed(8)
    entry.lng = scope.$resolve.position.coords.longitude.toFixed(8);
  } catch (e) {
    console.log(e);
  }
}


function transformData(data, scope) {
  if (Array.isArray(data)) {
    for (var i = 0, nbEntries = data.length; i < nbEntries; i++) {
      transformEntry(data[i]);
    }
  } else {
    transformEntry(data, scope);
  }
}
